var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgError(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 128 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: 0
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: 2
  }, /*#__PURE__*/React.createElement("stop", {
    id: "G",
    stopColor: "#eee"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "H",
    offset: 1,
    stopColor: "#eee",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: 3
  }, /*#__PURE__*/React.createElement("stop", {
    id: "I"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "J",
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: 4
  }, /*#__PURE__*/React.createElement("stop", {
    id: "K",
    stopColor: "#e85752"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "L",
    offset: 1,
    stopColor: "#d20303"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    cx: 60.05,
    cy: 51.39,
    r: 15.03,
    id: 5,
    xlinkHref: "#6",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-1.404511,1.1888571,-0.99999995,-1.1813958,199.73811,11.750541)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: 6
  }, /*#__PURE__*/React.createElement("stop", {
    id: "M",
    stopColor: "#eee"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "N",
    offset: 1,
    stopColor: "#dcdcdc"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    cx: 27.499,
    cy: 122.6,
    r: 18.17,
    id: 7,
    xlinkHref: "#3",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1,0,0,0.18918919,0,99.404179)"
  }), /*#__PURE__*/React.createElement("filter", {
    x: -0.02,
    y: -0.107,
    width: 1.04,
    height: 1.214,
    colorInterpolationFilters: "sRGB",
    id: 8
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.3065,
    id: "O"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    cx: 64.26,
    cy: -9.988,
    r: 56.927,
    id: 9,
    xlinkHref: "#2",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1.1553766,-1.5120518e-8,1.8629708e-8,1.4235179,-9.9843685,6.2909391)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    y1: 6.606,
    x2: 0,
    y2: 120.27,
    id: "A",
    xlinkHref: "#4",
    gradientUnits: "userSpaceOnUse"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: 1
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 45.667315,122.59849 a 18.168717,3.4373249 0 1 1 -36.3374333,0 18.168717,3.4373249 0 1 1 36.3374333,0 z",
    transform: "matrix(1.1351351,0,0,1,-8.6264905,0.49104638)",
    id: "B",
    opacity: 0.267,
    fill: "url(#7)",
    filter: "url(#8)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 45.667315,122.59849 a 18.168717,3.4373249 0 1 1 -36.3374333,0 18.168717,3.4373249 0 1 1 36.3374333,0 z",
    transform: "matrix(1.1351351,0,0,1,73.873324,0.49104638)",
    id: "C",
    opacity: 0.267,
    fill: "url(#7)",
    filter: "url(#8)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 7.0297901,18.815002 c -3.1848775,3.184876 -3.1848775,8.351719 0,11.536597 L 40.090688,63.412493 7.0297901,96.473392 c -3.1848689,3.184871 -3.1848775,8.351718 0,11.536598 L 19.688001,120.6682 c 3.184873,3.18488 8.298314,3.13146 11.483185,-0.0534 L 64.232085,87.553892 97.346391,120.6682 c 3.184879,3.18488 8.298309,3.13147 11.483189,-0.0534 l 12.6048,-12.6048 c 3.18487,-3.18488 3.23828,-8.298311 0.0534,-11.48319 L 88.373479,63.412493 121.43438,30.351599 c 3.18487,-3.184878 3.23828,-8.298312 0.0534,-11.483185 L 108.82958,6.2102012 c -3.18488,-3.1848775 -8.35172,-3.1848775 -11.536597,0 L 64.232085,39.271098 31.171186,6.2102012 c -3.184875,-3.1848775 -8.351721,-3.1848775 -11.536599,0 L 7.0297901,18.815002 z",
    id: "D",
    fill: "#9c0f0f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 25.40625,6.625 c -1.360633,0 -2.753272,0.5032718 -3.8125,1.5625 L 9,20.78125 C 6.8842834,22.896966 6.8842823,26.259282 9,28.375 l 33.0625,33.0625 a 2.7992363,2.7992363 0 0 1 0,3.9375 L 9,98.4375 c -2.1157081,2.11571 -2.1157163,5.47803 0,7.59375 l 12.65625,12.65625 c 2.12218,2.12218 5.396121,2.10387 7.53125,-0.0312 L 62.25,85.59375 a 2.7992363,2.7992363 0 0 1 3.9375,0 l 33.125,33.09375 c 2.11572,2.11572 5.43383,2.09741 7.5625,-0.0312 l 12.59375,-12.625 c 2.14161,-2.14161 2.17822,-5.41553 0.0625,-7.53125 l -33.125,-33.125 a 2.7992363,2.7992363 0 0 1 0,-3.9375 l 33.0625,-33.0625 c 2.14161,-2.141611 2.17821,-5.41554 0.0625,-7.53125 L 106.875,8.1875 c -2.10925,-2.1092467 -5.51575,-2.1092467 -7.625,0 L 66.1875,41.25 a 2.7992363,2.7992363 0 0 1 -3.9375,0 L 29.1875,8.1875 C 28.115329,7.1153277 26.766883,6.625 25.40625,6.625 z",
    id: "E",
    fill: "url(#A)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 103.0625,7.53125 c -1.13473,0 -2.27749,0.433733 -3.15625,1.3125 l -33.0625,33.0625 c -1.448136,1.432735 -3.801864,1.432735 -5.25,0 L 28.53125,8.84375 C 27.635826,7.9483253 26.541791,7.5625 25.40625,7.5625 24.276651,7.5625 23.123806,7.9699439 22.25,8.84375 L 9.65625,21.4375 c -1.7647621,1.764762 -1.7647634,4.516486 0,6.28125 l 33.0625,33.0625 c 1.432735,1.448136 1.432735,3.801864 0,5.25 l -33.0625,33.0625 c -1.7647531,1.76475 -1.7647614,4.51649 0,6.28125 l 12.65625,12.65625 c 1.779585,1.77959 4.420351,1.76714 6.21875,-0.0312 l 33.0625,-33.0625 c 1.448136,-1.432735 3.801864,-1.432735 5.25,0 l 33.125,33.09375 c 1.76747,1.76747 4.46366,1.75508 6.25,-0.0312 l 12.59375,-12.625 c 1.80779,-1.80779 1.83267,-4.44858 0.0625,-6.21875 L 85.75,66.03125 c -1.432735,-1.448136 -1.432735,-3.801864 0,-5.25 l 33.0625,-33.0625 c 1.80779,-1.807788 1.83266,-4.44859 0.0625,-6.21875 L 106.21875,8.84375 c -0.87878,-0.8787726 -2.02152,-1.3125 -3.15625,-1.3125 z",
    id: "F",
    fill: "none",
    stroke: "url(#9)",
    strokeWidth: 2
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.79cd77c880081c87047d8e8ae9032700.svg";
export { ForwardRef as ReactComponent };